"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgramItem = void 0;
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./ProgramItem.css"));
var _uiKit = require("@cian/ui-kit");
var _assets = require("../../../../assets");
var _utils = require("@cian/utils");
var _RateCell = require("../../../RateCell");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ProgramItem = _ref => {
  let {
    id,
    name,
    payment,
    rate,
    escrowRate,
    showEscrow,
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['item'],
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['title']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading4, null, name)), /*#__PURE__*/React.createElement("div", {
    className: styles['content']
  }, /*#__PURE__*/React.createElement("img", {
    className: styles['icon'],
    src: _assets.programIcons[id]
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_uiKit.ArticleParagraph1, null, (0, _utils.numberToPrettyString)(payment), " \u20BD/\u043C\u0435\u0441"), /*#__PURE__*/React.createElement(_RateCell.RateCell, {
    showEscrow: showEscrow,
    rate: rate,
    escrowRate: escrowRate
  }))));
};
exports.ProgramItem = ProgramItem;